$('.js-prevent-link a').on('click',(event) => {
    // Prevent the event from propagating to parent elements
    event.stopPropagation();
});
